// removed by extract-text-webpack-plugin
module.exports = {"aboutCompany":"_30qg7rRF0CnpGJbhWiIrNd","communityStamp":"yzm30SzRtwUJNQdaqxXhR","galleryWrapper":"_2UNkJ18YVryIaxaxrhCSoT","defaultLang":"_1lrtH_eIURir1J9OoubhJL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutCompany/AboutCompany.scss
// module id = 1553
// module chunks = 0